import Vue from 'vue';
import Component from 'vue-class-component';
import {Route} from 'vue-router';
import EventBus from '@/EventBus';
import {GlobalEvent} from '@/events';

//@ts-ignore
@Component.registerHooks([
	'beforeRouteLeave',
	'beforeRouteEnter'
])

//@ts-ignore
@Component
abstract class StepView extends Vue
{
	private beforeRouteLeave(to: Route, from: Route, next: () => void)
	{
		if (from.meta.allowFiles)
		{
			EventBus.$emit(GlobalEvent.SaveFiles, from);
		}

		if (from.meta.allowNotes)
		{
			EventBus.$emit(GlobalEvent.SaveNotes, from);
		}

		next();
	}

	private beforeRouteEnter(to: Route, from: Route, next: () => void)
	{
		if (to.meta.allowFiles)
		{
			EventBus.$emit(GlobalEvent.LoadFiles, to);
		}

		if (to.meta.allowNotes)
		{
			EventBus.$emit(GlobalEvent.LoadNotes, to);
		}

		next();
	}
}

export default StepView;